(ns frontend.view.settings2.surveys.timeseries.tab-metrics
  (:require [common.localization :as loc]
            [frontend.view.settings2.surveys.events :as config-events]
            [frontend.view.settings2.surveys.timeseries.event :as events]
            [frontend.view.settings2.surveys.timeseries.sub :as subs]
            [oops.core :as oops]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [ui.components.button.view :as button]
            [ui.components.grid.view :as grid]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn add-question
  [{:keys [block-idx]}]
  [:div
   {:class "flex-auto py-2 px-12"}
   [labelled-input/view
    {:placeholder        (loc/tr :add-question)
     :data-type          :data.type/ref-single
     :editor-type        :editor.type/search
     :on-change          (fn [value]
                           (rf/dispatch [::config-events/add-table-question block-idx value]))
     :value              nil                                                                        ;; control -> choose the value outside, not inside the component
     ;; extra params for the component
     :field/entity-types [:entity.type/survey-question]}]])

(defn toolbar
  [{:keys [ctx-path block-idx] :as ctx}]
  (let [selected-questions @(rf/subscribe [::subs/selected-questions ctx-path])]
    [:div
     {:class "flex flex-col gap-4"}
     [:div
      [button/sm-secondary-hollow
       {:on-click  (fn [_]
                     (rf/dispatch [::config-events/remove-selected-questions block-idx selected-questions])
                     (rf/dispatch [::events/remove-selected-questions (assoc ctx :ids selected-questions)]))
        :disabled? (empty? selected-questions)}
       [:i.fal.fa-trash-alt]
       (loc/tr :remove-selected)]]]))

(defn view
  [{:keys [ctx-path block-idx] :as ctx} {:keys [content] :as _block}]
  (let [row-to-highlight @(rf/subscribe [::subs/row-to-highlight ctx-path])]
    [:div
     {:class "flex flex-column gap-4"}
     [toolbar ctx]
     [:div
      [grid/ag-grid
       {:theme                         grid/theme-quartz
        :columnDefs                    [{:headerName        (loc/tr :label)
                                         :field             :localized-label
                                         :resizable         true
                                         :rowDrag           true
                                         :editable          false
                                         :suppressMovable   true}]
        :sizeColumnsToFit              true
        :getRowId                      (fn [data-js]
                                         (let [row-id (oops/oget data-js "data.id")]
                                           row-id))
        :defaultColDef                 {:sortable false}
        :rowData                       (->> content
                                            (filter :localized-label))
        :getRowClass                   (fn [params]                                                  ;;To highlight when dragging the row
                                         (let [node (oops/oget params "node")
                                               old-index (oops/oget node "rowIndex")]
                                           (if (= old-index row-to-highlight)
                                             "bg-[#2196F319]" "")))
        :resetRowDataOnUpdate          true
        :detailRowAutoHeight           true
        :domLayout                     "autoHeight"                                                  ;; "autoHeight"
        :autoResizeColumns             true
        :rowBuffer                     100
        :onGridReady                   (fn [event]
                                         (oops/ocall event "api.sizeColumnsToFit"))
        :enableSorting                 false
        :suppressColumnVirtualisation  false
        :suppressColumnMoveAnimation   false
        :suppressScrollOnNewData       true
        :suppressRowDrag               false
        :pivotPanelShow                "never"
        :onToolPanelSizeChanged        (constantly nil)
        :enableCellTextSelection       "false"
        :ensureDomOrder                true
        :animateRows                   true
        :rowDeselection                true
        :suppressGroupRowsSticky       true
        :rowSelection {:mode "multiRow"}
        :groupDisplayType              "multipleColumns"
        :onSelectionChanged            (fn [params]
                                         (let [grid-api (oops/oget params "api")
                                               selection-state-js (oops/ocall grid-api "getSelectedRows")
                                               selection-state (js->clj selection-state-js :keywordize-keys true)
                                               selected-ids (->> selection-state
                                                                 (map :id)
                                                                 (set))]
                                           (try
                                             (rf/dispatch [::events/set-selected-question-ids (assoc ctx :ids selected-ids)])
                                             nil
                                             (catch js/Object _o))))
        :selection                     {:mode "multiRow"}
        :onRowDragMove                 (fn [params]
                                         (let [over-node (oops/oget params "overNode")
                                               over-index (when-not (nil? over-node)
                                                            (oops/oget over-node "rowIndex"))]
                                           (rf/dispatch [::events/on-row-drag-move (assoc ctx :over-index over-index)])))
        :onRowDragEnd                  (fn [params-js]
                                         (let [node-js (oops/oget params-js "node")
                                               old-index (oops/oget node-js "rowIndex")
                                               over-node (oops/oget params-js "overNode")
                                               new-index (when-not (nil? over-node)
                                                           (oops/oget over-node "rowIndex"))]
                                           (rf/dispatch [::config-events/move-table-question block-idx old-index new-index])
                                           (rf/dispatch [::events/on-row-drag-end ctx])))
        :suppressDragLeaveHidesColumns true
        :readOnlyEdit                  true
        :stopEditingWhenCellsLoseFocus true
        :noRowsOverlayComponent        (fn []
                                         (r/as-element
                                          [:div]))}]
      [add-question ctx]]]))
